import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { ReportStatusTypes } from "../../utils";

export const ReportStatusDropdown = ({
  value,
  isMulti = false,
  className,
  onSelect,
  placeholder,
  isShowAll = false,
  ...props
}) => {
  const [list, setList] = useState();

  useEffect(() => {
    if (isShowAll) {
      const allOption = { id: 0, label: "All", value: "" };
      setList([allOption, ...ReportStatusTypes]);
    } else {
      setList(ReportStatusTypes);
    }
  }, [isShowAll]);

  return (
    <RSelect
      className={className}
      options={list ?? []}
      isMulti={isMulti}
      placeholder={placeholder}
      value={value ?? (isShowAll ? (list ? list[0] : null) : null)}
      onChange={(e) => {
        if (isShowAll === false) {
          onSelect(e);
        } else {
          e?.id === 0 ? onSelect(undefined) : onSelect(e);
        }
      }}
      {...props}
    />
  );
};
